import React from "react";
import { useLocation } from "react-router-dom";

interface GamePageBannerProps {
    gameMainPageData: any;
    langData: any;
    defaultTitle?: string;
    overrideBackgroundUrl?: string;
}

const GamePageBanner: React.FC<GamePageBannerProps> = ({ gameMainPageData, langData, defaultTitle, overrideBackgroundUrl }) => {
    const location = useLocation();

    // gameMainPageData가 로드되지 않았으면 기본 배너 표시
    if (!gameMainPageData?.menu) {
        return (
            <div className="csMainBnr newsMainBnr">
                <h1>{defaultTitle || langData?.GLB__COMM_TITL_LBL_00 || ''}</h1>
            </div>
        );
    }

    // URL 파라미터 추출
    const getCurrentParams = () => {
        const currentParams = new URLSearchParams(location.search);
        return {
            currentCtntCtgrCd: currentParams.get("ctntKindCd") || currentParams.get('shopKindCd')
        };
    };

    const currentParams = getCurrentParams();

    // 현재 URL에서 대메뉴 찾기
    let currentMainMenu;
    
    // 1. ctntKindCd 파라미터가 있는 경우: 메뉴 자체 또는 subMenuLst에서 일치하는 항목 찾기
    if (currentParams.currentCtntCtgrCd) {
        currentMainMenu = gameMainPageData?.menu?.find((menu: any) => {
            // 1-1. 메뉴 자체의 url에서 ctntKindCd 확인
            const menuUrlParams = new URLSearchParams(menu.url?.split('?')[1] || '');
            const menuCtntKindCd = menuUrlParams.get('ctntKindCd');
            if (menuCtntKindCd === currentParams.currentCtntCtgrCd) {
                return true;
            }
            
            // 1-2. subMenuLst에서 ctntKindCd 확인
            return menu.subMenuLst?.some((sub: any) => {
                const urlParams = new URLSearchParams(sub.url?.split('?')[1] || '');
                const subCtntKindCd = urlParams.get('ctntKindCd');
                return subCtntKindCd === currentParams.currentCtntCtgrCd;
            });
        });
    }
    
    // 2. 1번에서 못 찾았거나 ctntKindCd가 없는 경우: URL 경로 유사성으로 찾기
    if (!currentMainMenu) {
        const currentPath = location.pathname.toLowerCase();
        currentMainMenu = gameMainPageData?.menu?.find((menu: any) => {
            const menuUrl = menu.url?.toLowerCase() || '';
            const menuCd = menu.menuCd?.toLowerCase() || '';

            return currentPath.includes(menuCd) || 
                   (menuUrl && currentPath.includes(menuUrl.split('?')[0])) ||
                   menu.subMenuLst?.some((sub: any) => {
                       const subUrl = sub.url?.toLowerCase() || '';
                       const subMenuCd = sub.menuCd?.toLowerCase() || '';
                       return currentPath.includes(subMenuCd) || 
                              (subUrl && currentPath.includes(subUrl.split('?')[0]));
                   });
        });
    }

    return (
        <div 
            className="csMainBnr newsMainBnr" 
            style={{
                backgroundImage: (overrideBackgroundUrl || currentMainMenu?.bnrUrl) ? `url(${overrideBackgroundUrl || currentMainMenu?.bnrUrl})` : undefined,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >
        </div>
    );
};

export default GamePageBanner;
